@if (currentPage() && pageIndices().length > 1) {
<ul class="product-list-paging">
  <li>
    @if (currentPage() > 1) {
    <a
      [routerLink]="[]"
      queryParamsHandling="merge"
      [queryParams]="{ page: currentPage() - 1 }"
      [fragment]="fragmentOnRouting()"
      >&laquo;</a
    >
    } @else {
    <span>&laquo;</span>
    }
  </li>
  @for (p of pageIndices(); track p) {
  <li>
    <a
      [routerLink]="[]"
      queryParamsHandling="merge"
      [queryParams]="{ page: p.value }"
      [fragment]="fragmentOnRouting()"
      [ngClass]="{ active: p.value === currentPage() }"
      >{{ p.display }}</a
    >
  </li>
  }
  <li class="pagination-list-next">
    @if (pageIndices()[pageIndices().length - 1].value !== currentPage()) {
    <a
      [routerLink]="[]"
      queryParamsHandling="merge"
      [queryParams]="{ page: currentPage() + 1 }"
      [fragment]="fragmentOnRouting()"
      >&raquo;</a
    >
    } @else {
    <span>&raquo;</span>
    }
  </li>
</ul>
}
